/* Phone-only care icon strip. Progressive enhancement: without JS the care cards stay as a list. */
class TechTeesCareTabs extends HTMLElement {
  connectedCallback() {
    var list = this.querySelector('ul');
    if (!list || this.tabs) return;
    var items = Array.prototype.slice.call(list.children);
    if (items.length < 2) return;
    var uid = 'tt-care-' + (TechTeesCareTabs.count = (TechTeesCareTabs.count || 0) + 1);
    var wrap = document.createElement('div');
    wrap.className = 'tt-care-tabs';
    var strip = document.createElement('div');
    strip.className = 'tt-care-tabs__strip';
    strip.setAttribute('role', 'tablist');
    strip.setAttribute('aria-label', list.getAttribute('aria-label') || 'Care instructions');
    var panel = document.createElement('div');
    panel.className = 'tt-care-tabs__panel';
    panel.id = uid + '-panel';
    panel.setAttribute('role', 'tabpanel');
    panel.tabIndex = 0;
    var title = document.createElement('h3');
    var text = document.createElement('p');
    panel.appendChild(title);
    panel.appendChild(text);
    this.data = [];
    this.tabs = items.map(function (li, i) {
      var h = li.querySelector('h3');
      var p = li.querySelector('p');
      var svg = li.querySelector('svg');
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'tt-care-tabs__tab';
      tab.id = uid + '-tab-' + i;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panel.id);
      tab.setAttribute('aria-label', h ? h.textContent : 'Care ' + (i + 1));
      if (svg) tab.appendChild(svg.cloneNode(true));
      strip.appendChild(tab);
      this.data.push({ title: h ? h.textContent : '', text: p ? p.textContent : '' });
      return tab;
    }, this);
    wrap.appendChild(strip);
    wrap.appendChild(panel);
    list.parentNode.insertBefore(wrap, list.nextSibling);
    this.strip = strip;
    this.panel = panel;
    this.titleEl = title;
    this.textEl = text;
    this.onKey = this.onKey.bind(this);
    this.onResize = this.place.bind(this);
    this.tabs.forEach(function (tab, i) {
      tab.addEventListener('click', this.select.bind(this, i, false));
      tab.addEventListener('keydown', this.onKey);
    }, this);
    window.addEventListener('resize', this.onResize);
    this.classList.add('is-ready');
    this.select(0, false);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
  }
  onKey(e) {
    var i = this.tabs.indexOf(e.currentTarget);
    var n = this.tabs.length;
    var next = null;
    if (e.key === 'ArrowRight') next = (i + 1) % n;
    else if (e.key === 'ArrowLeft') next = (i + n - 1) % n;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = n - 1;
    if (next === null) return;
    e.preventDefault();
    this.select(next, true);
  }
  select(i, focus) {
    this.index = i;
    this.tabs.forEach(function (tab, j) {
      tab.setAttribute('aria-selected', j === i ? 'true' : 'false');
      tab.tabIndex = j === i ? 0 : -1;
    });
    this.panel.setAttribute('aria-labelledby', this.tabs[i].id);
    this.titleEl.textContent = this.data[i].title;
    this.textEl.textContent = this.data[i].text;
    this.place();
    if (focus) this.tabs[i].focus();
  }
  place() {
    var tab = this.tabs[this.index];
    if (!tab || !tab.offsetWidth) return;
    var t = tab.getBoundingClientRect();
    var p = this.panel.getBoundingClientRect();
    this.panel.style.setProperty('--tt-nx', (t.left + t.width / 2 - p.left) + 'px');
  }
}
if (!customElements.get('techtees-care-tabs')) customElements.define('techtees-care-tabs', TechTeesCareTabs);
